export const ACCOUNT_REMOVAL_TITLE = "Remove account?";
export const ACCOUNT_REMOVAL_MESSAGE =
  "Accounts without business history will be permanently deleted, including their contact details and setup. Accounts with business history will be deactivated and all related records will be preserved.";
